<template>
    <div class="autocomplete-suggestions">
        <Suggestion
            v-for="(suggestion, index) in suggestions"
            :key="index"
            :suggestion="suggestion"
            :query="query"
            @click="setSuggestion(suggestion)"
        />
    </div>
</template>

<script setup lang="ts">
    import Suggestion from './Suggestion.vue';
    import { ProductInterface } from './models/SuggestionInterface.ts';

    interface SuggestionProps {
        suggestions: ProductInterface[];
        query: String;
    }

    defineProps<SuggestionProps>();
    const emit = defineEmits(['handleSetSuggestion']);

    const setSuggestion = (suggestion) => {
        emit('handleSetSuggestion', suggestion);
    };
</script>

<style>
    .autocomplete-suggestions {
        border: 1px solid #ddd;
        position: absolute;
        z-index: 10;
        width: 100%;
        position: absolute;
    }
</style>
